module.exports = __webpack_public_path__ + "img/top.45abc962.png";